<script>
import {ElNotification} from "element-plus";

export default {
  name: "SchoolBoardForm",
  data() {
    return {
      loading: false,
      form: {
        id: null,
        title: null,
        description: null,
        rules: null,
        year: "2024",
        season: 0,
        initiatives_max_amount: 0,
        accepting_start: null,
        accepting_end: null,
        moderating_start: null,
        moderating_end: null,
        voting_start: null,
        voting_end: null,
        budget: 0
      },

      rules: {
        title: [{required: true, message: "Majburiy maydon", trigger: "blur"}],
        description: [{required: true, message: "Majburiy maydon", trigger: "blur"}],
        season: [{required: true, message: "Majburiy maydon", trigger: "blur"}],
        initiatives_max_amount: [{required: true, message: "Majburiy maydon", trigger: "blur"}],
        budget: [{required: true, message: "Majburiy maydon", trigger: "blur"}],
        accepting_start: [{required: true, message: "Majburiy maydon", trigger: "change"}],
        accepting_end: [{required: true, message: "Majburiy maydon", trigger: "change"}],
        moderating_start: [{required: true, message: "Majburiy maydon", trigger: "change"}],
        moderating_end: [{required: true, message: "Majburiy maydon", trigger: "change"}],
        voting_start: [{required: true, message: "Majburiy maydon", trigger: "change"}],
        voting_end: [{required: true, message: "Majburiy maydon", trigger: "change"}],
      }
    }
  },
  methods: {
    onSubmit() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.loading = true;
          this.form.year = parseInt(this.form.year)
          let http;
          if (this.form.id) {
            http = this.$http.put(`/api/v1/my-school/boards/${this.form.id}`, this.form);
          } else {
            http = this.$http.post("/api/v1/my-school/boards", this.form);
          }

          http
              .then(() => {
                ElNotification({
                  title: "Tabriklaymiz",
                  message: "Muvafaqiyatli saqlandi",
                  type: "success",
                });
                this.$router.go(-1);
              })
              .catch(({response}) => {
                ElNotification({
                  title: "Xatolik",
                  message:
                      response.data.message || "Iltimos, qayta urinib ko'ring.",
                  type: "error",
                });
              })
              .finally(() => {
                this.loading = false;
              });
        }
      })
    },

    getBoard() {
      this.loading = true;
      this.$http
          .get(`api/v1/my-school/boards/${this.form.id}`)
          .then(({data}) => {
            this.form = data;
            this.form.year = data.year.toString()
          })
          .catch((error) => {
            ElNotification.error({
              message:
                  error.response.data.message ||
                  "Amaliyotni bajarishda xatolik sodir bo'ldi. iltimos qayta urinib ko'ring!",
            });
          })
          .finally(() => {
            this.loading = false;
          });
    },
  },
  mounted() {
    if (this.$route.params.id) {
      this.form.id = this.$route.params.id;
      this.getBoard()
    }
  }
}
</script>

<template>
  <div class="accept-initiative">
    <div class="form" v-loading="loading">
      <el-row>
        <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12">
          <el-form
              ref="form"
              :model="form"
              :rules="rules"
              label-position="top"
              style="width: 100%"
              status-icon
          >
            <el-row :gutter="10">
              <el-col :xs="24" :sm="24" :md="8" :lg="8" :xl="8">
                <el-form-item label="Nomi" prop="title">
                  <el-input size="large" v-model="form.title" placeholder="Board nomini kiriting" clearable
                            style="width: 100%"/>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="24" :md="8" :lg="8" :xl="8">
                <el-form-item label="Yil" prop="year">
                  <el-date-picker
                      size="large"
                      style="width: 100%"
                      v-model="form.year"
                      type="year"
                      format="YYYY"
                      value-format="YYYY"
                      clearable
                      placeholder="Yilni tanlang"
                  />
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="24" :md="8" :lg="8" :xl="8">
                <el-form-item label="Mavsum" prop="season">
                  <el-input-number
                      style="width: 100%"
                      size="large"
                      class="form-input"
                      v-model="form.season"
                      type="number"
                  />
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="8">
                <el-form-item label="Ajratilgan mablag'" prop="budget">
                  <el-input-number
                      style="width: 100%"
                      size="large"
                      class="form-input"
                      v-model="form.budget"
                      type="number"
                  />
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="8">
                <el-form-item label="Tashabbus maksimal qiymati" prop="initiatives_max_amount">
                  <el-input-number
                      style="width: 100%"
                      size="large"
                      class="form-input"
                      v-model="form.initiatives_max_amount"
                      type="number"
                  />
                </el-form-item>
              </el-col>
            </el-row>
            <fieldset class="form-fieldset">
              <legend>Qabul qilish sanasi</legend>
              <el-row :gutter="10">
                <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
                  <el-form-item label="Boshlanish" prop="accepting_start">
                    <el-date-picker
                        size="large"
                        style="width: 100%"
                        v-model="form.accepting_start"
                        type="datetime"
                        format="DD/MM/YYYY HH:mm:ss"
                        placeholder="Tanlang"
                    />
                  </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
                  <el-form-item label="Tugash" prop="accepting_end">
                    <el-date-picker
                        size="large"
                        style="width: 100%"
                        v-model="form.accepting_end"
                        type="datetime"
                        format="DD/MM/YYYY HH:mm:ss"
                        placeholder="Tanlang"
                    />
                  </el-form-item>
                </el-col>
              </el-row>
            </fieldset>
            <fieldset class="form-fieldset">
              <legend>Moderatsiya qilish sanasi</legend>
              <el-row :gutter="10">
                <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
                  <el-form-item label="Boshlanish" prop="moderating_start">
                    <el-date-picker
                        size="large"
                        style="width: 100%"
                        v-model="form.moderating_start"
                        type="datetime"
                        format="DD/MM/YYYY HH:mm:ss"
                        placeholder="Tanlang"
                    />
                  </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
                  <el-form-item label="Tugash" prop="moderating_end">
                    <el-date-picker
                        size="large"
                        style="width: 100%"
                        v-model="form.moderating_end"
                        type="datetime"
                        format="DD/MM/YYYY HH:mm:ss"
                        placeholder="Tanlang"
                    />
                  </el-form-item>
                </el-col>
              </el-row>
            </fieldset>
            <fieldset class="form-fieldset">
              <legend>Ovoz berishni sanasi</legend>
              <el-row :gutter="10">
                <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
                  <el-form-item label="Boshlanishi" prop="voting_start">
                    <el-date-picker
                        size="large"
                        style="width: 100%"
                        v-model="form.voting_start"
                        type="datetime"
                        format="DD/MM/YYYY HH:mm:ss"
                        placeholder="Tanlang"
                    />
                  </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
                  <el-form-item label="Tugashi" prop="voting_end">
                    <el-date-picker
                        size="large"
                        style="width: 100%"
                        v-model="form.voting_end"
                        type="datetime"
                        format="DD/MM/YYYY HH:mm:ss"
                        placeholder="Tanlang"
                    />
                  </el-form-item>
                </el-col>
              </el-row>
            </fieldset>
            <el-row :gutter="10" style="margin-top: 20px">
              <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="8">
                <el-form-item label="Doska mazmuni" prop="description">
                  <el-input
                      style="width: 100%"
                      size="large"
                      class="form-input"
                      :rows="3"
                      v-model="form.description"
                      type="textarea"
                  />
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="8">
                <el-form-item label="Qoidalar" prop="rules">
                  <el-input
                      style="width: 100%"
                      size="large"
                      class="form-input"
                      :rows="3"
                      v-model="form.rules"
                      type="textarea"
                  />
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="10">
              <el-col :span="24">
                <el-form-item>
                  <el-button class="custom-btn" @click="() => this.$router.go(-1)"
                  >Orqaga
                  </el-button
                  >
                  <el-button class="custom-btn" type="primary" @click="onSubmit"
                  >Saqlash
                  </el-button
                  >
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<style scoped lang="scss">

.form-fieldset {
  border: 1px solid rgba(137, 141, 141, 0.2);
  border-radius: 5px;
  padding: 5px 8px;

  &:nth-child(3) {
    margin: 20px 0;
  }

  legend {
    font-style: italic;
    font-weight: bold;
  }
}
</style>
